/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { RestaurantGroupMapEntity } from '../model/restaurantGroupMapEntity';
import { SmartDineResponseRestaurantGroupMapEntity } from '../model/smartDineResponseRestaurantGroupMapEntity';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class RestaurantGroupMapRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUserRestaurantGroupMapMaps(body: RestaurantGroupMapEntity, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantGroupMapEntity>;
    public createUserRestaurantGroupMapMaps(body: RestaurantGroupMapEntity, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantGroupMapEntity>>;
    public createUserRestaurantGroupMapMaps(body: RestaurantGroupMapEntity, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantGroupMapEntity>>;
    public createUserRestaurantGroupMapMaps(body: RestaurantGroupMapEntity, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createUserRestaurantGroupMapMaps.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseRestaurantGroupMapEntity>('post',`${this.basePath}/api/admin/restaurantgroupmaps`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantGroupMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRestaurantGroupMap(restaurantGroupMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantGroupMapEntity>;
    public deleteRestaurantGroupMap(restaurantGroupMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantGroupMapEntity>>;
    public deleteRestaurantGroupMap(restaurantGroupMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantGroupMapEntity>>;
    public deleteRestaurantGroupMap(restaurantGroupMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantGroupMapId === null || restaurantGroupMapId === undefined) {
            throw new Error('Required parameter restaurantGroupMapId was null or undefined when calling deleteRestaurantGroupMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantGroupMapEntity>('delete',`${this.basePath}/api/admin/restaurantgroupmaps/${encodeURIComponent(String(restaurantGroupMapId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantGroupMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRestaurantGroupMap(restaurantGroupMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantGroupMapEntity>;
    public getRestaurantGroupMap(restaurantGroupMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantGroupMapEntity>>;
    public getRestaurantGroupMap(restaurantGroupMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantGroupMapEntity>>;
    public getRestaurantGroupMap(restaurantGroupMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantGroupMapId === null || restaurantGroupMapId === undefined) {
            throw new Error('Required parameter restaurantGroupMapId was null or undefined when calling getRestaurantGroupMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantGroupMapEntity>('get',`${this.basePath}/api/admin/restaurantgroupmaps/${encodeURIComponent(String(restaurantGroupMapId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRestaurantGroupMaps(observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantGroupMapEntity>;
    public getRestaurantGroupMaps(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantGroupMapEntity>>;
    public getRestaurantGroupMaps(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantGroupMapEntity>>;
    public getRestaurantGroupMaps(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantGroupMapEntity>('get',`${this.basePath}/api/admin/restaurantgroupmaps`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param restaurantGroupMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRestaurantGroupMap(body: RestaurantGroupMapEntity, restaurantGroupMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantGroupMapEntity>;
    public updateRestaurantGroupMap(body: RestaurantGroupMapEntity, restaurantGroupMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantGroupMapEntity>>;
    public updateRestaurantGroupMap(body: RestaurantGroupMapEntity, restaurantGroupMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantGroupMapEntity>>;
    public updateRestaurantGroupMap(body: RestaurantGroupMapEntity, restaurantGroupMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateRestaurantGroupMap.');
        }

        if (restaurantGroupMapId === null || restaurantGroupMapId === undefined) {
            throw new Error('Required parameter restaurantGroupMapId was null or undefined when calling updateRestaurantGroupMap.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseRestaurantGroupMapEntity>('put',`${this.basePath}/api/admin/restaurantgroupmaps/${encodeURIComponent(String(restaurantGroupMapId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
